import type { ProductFormType } from "src/pages/Product/ProductForm/ProductForm.types";

export const getTotalUsedQuantityGrams = (productIngredients: ProductFormType["productIngredients"]): number => {
    return Math.round(productIngredients.reduce((total, ingredient) => total + (ingredient.usedQuantity ?? 0), 0));
};
